export default "__VITE_ASSET__DgcaXAf1__$_?url__"